import clock from "./clock.svg";
import sun from "./half-sun.svg";
import star from "./star.svg";

export const BIG_EMISSION_ICONS = { clock, sun, star };
